import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-width: 25vw;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		min-width: 100%;
	}
`;

export const twoInputs = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: center;
`;

export const inputsDate = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: center;
`;
